import { VerticalForm } from "melco-shared-logic";
import { MachineGroupsList } from "./MachineGroupsList";

type DisplayMachineGroupsFormProps = {};
export const DisplayMachineGroupsForm: React.FC<
  DisplayMachineGroupsFormProps
> = ({}) => {
  return (
    <>
      <VerticalForm>
        <MachineGroupsList />
      </VerticalForm>
    </>
  );
};
